import { render } from "./Vaksin.vue?vue&type=template&id=c7520ac2"
import script from "./Vaksin.vue?vue&type=script&lang=js"
export * from "./Vaksin.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__